module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Semibold.8f079b59.otf";